module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('center', [(_vm.isTowerCo()) ? _c('el-row', [_c('dash-text', {
    attrs: {
      "caption": "Share Ratio",
      "value": this.formatNumber(_vm.stats.sharingRatio, 2) + '%',
      "color": "navy",
      "icon": "fa fa-share-alt",
      "icon-color": "lightgrey",
      "no-plural": "",
      "align": "center"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('el-row', [_c('table', {
    staticClass: "el-table"
  }, [(_vm.stats.sitesActive) ? _c('tr', [_c('td', {
    staticClass: "text-primary"
  }, [_vm._v("Active")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--primary is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/active"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesActive)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesCandidate) ? _c('tr', [_c('td', {
    staticClass: "text-warning"
  }, [_vm._v("Candidate")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--warning is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/candidate"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesCandidate)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesDismantled) ? _c('tr', [_c('td', {
    staticClass: "text-danger"
  }, [_vm._v("Dismantled")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--danger is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/dismantled"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesDismantled)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesExclusive) ? _c('tr', [_c('td', {
    staticClass: "text-black"
  }, [_vm._v("Exclusive")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--info is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/exclusive"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesExclusive)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesLandOnly) ? _c('tr', [_c('td', {
    staticClass: "text-info"
  }, [_vm._v("Land Only")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--info is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/land-only"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesLandOnly)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesNew) ? _c('tr', [_c('td', {
    staticClass: "text-success"
  }, [_vm._v("New")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--success is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/new"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesNew)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesSold) ? _c('tr', [_c('td', {
    staticClass: "text-info"
  }, [_vm._v("Sold")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--danger is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/sold"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesSold)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesTemporary) ? _c('tr', [_c('td', {
    staticClass: "text-info"
  }, [_vm._v("Temporary")]), _vm._v(" "), _c('td', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button el-button--info is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites/temporary"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesTemporary)))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.stats.sitesTotal) ? _c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('b', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "el-button is-round is-plain el-button--mini",
    attrs: {
      "tag": "el-button",
      "to": "sites"
    }
  }, [_vm._v(_vm._s(this.formatInteger(_vm.stats.sitesTotal)))])], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('div', [_c('el-row', [_vm._v("\n        Total Sharers: "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.stats.sharers, 0)))])]), _vm._v(" "), _c('el-row', [_vm._v("\n        Total Exclude Sharers: "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.stats.excludeSharers, 0)))])]), _vm._v(" "), _c('el-row', [_vm._v("\n        Total Ways: "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.stats.totalWays, 0)))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a497dfb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/SitesStatsTable.vue
// module id = 1685
// module chunks = 0